import React from 'react'

const Voitot = ({ voitot, prizes }) => {
    const list = prizes.map(teksti => {
        return (
            <li>
                <div className={'marker'}></div>
                <div className="text">
                    <div className={'content'}>{teksti.text}</div>
                </div>
                <div className={'marker2'}></div>
            </li>
        )
    })

    return (
        <table>
            <tbody>
                <tr>
                    <td>{list}</td>
                </tr>
            </tbody>
        </table>
    )
}

export default Voitot
